<template>
    <v-menu>
        <template v-slot:activator="{ props }">
            <v-btn
                style="width: 2rem; height: 2rem; background-color: transparent; border: 1px solid var(--cor-separador); color: var(--cor-fonte);"
                class="acao-secundaria" icon="mdi-dots-horizontal" v-bind="props"></v-btn>
        </template>

        <v-list style="background-color: var(--cor-bg); color: var(--cor-fonte);">
            <v-list-item @click="$emit('editarTarefa', tarefa)">
                Editar Tarefa
            </v-list-item>
            <v-list-item :disabled="!isCoordenador && !isAuditor" @click="$emit('criarTarefa', tarefa)"
                v-if="podeCriarTarefa"
                style="background-color: var(--cor-bg); color: var(--cor-fonte);">
                Criar Tarefa
            </v-list-item>
            <v-list-item :disabled="!isCoordenador && !isAuditor" class="txt-erro" @click="confirmarExclusão">
                Excluir Tarefa
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
export default {
    name: 'OptionsTarefa',

    props: {
        propTarefa: {
            required: true
        },
        isAuditor: {
            required: true
        },
        isCoordenador: {
            required: true
        },
        podeCriarTarefa: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            tarefa: this.propTarefa,
        }
    },

    methods: {
        confirmarExclusão() {
            this.$emit('apagarTarefa', this.tarefa.id);
        }
    },

}
</script>

<style scoped></style>